import { render, staticRenderFns } from "./serviceWindow.vue?vue&type=template&id=63de8510&scoped=true&"
import script from "./serviceWindow.vue?vue&type=script&lang=js&"
export * from "./serviceWindow.vue?vue&type=script&lang=js&"
import style0 from "./serviceWindow.vue?vue&type=style&index=0&id=63de8510&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63de8510",
  null
  
)

export default component.exports